/* eslint-disable @typescript-eslint/no-inferrable-types */
import {
  PaginatedSupplierOrders,
  PaginatedSupplierProductCodes,
  PaginatedSuppliers,
  ProductCheckResponse,
  RptSupplierOrders,
  Supplier,
  SupplierOrderDataEntryForm,
} from "types/model.types";
import { authApi } from "./";

const apiSupplierPrefix = "supplier";

//#region Suppliers

export const deleteSupplierOrderById = async (
  id: number,
): Promise<void | any> => {
  const { data } = await authApi.post<any>(
    `${apiSupplierPrefix}/deleteSupplierOrderById`,
    {
      id,
    },
  );
  return data;
};
export const getSuppliers = async (
  pageNumber: number = 1,
  pageSize: number = 30,
): Promise<void | PaginatedSuppliers> => {
  const { data } = await authApi.post<PaginatedSuppliers>(
    `${apiSupplierPrefix}/get`,
    {
      pageNumber,
      pageSize,
    },
  );

  return data ?? [];
};
/** Delete entire supplier order details */
export const resetSupplierOrderDetails = async (
  orderId: number,
): Promise<void | any> => {
  const { data } = await authApi.post<any>(
    `${apiSupplierPrefix}/resetSupplierOrderDetails`,
    {
      orderId,
    },
  );
  return data;
};
export const deleteSupplierOrderDetailsById = async (
  orderId: number,
  orderDetailsId: number,
): Promise<void | any> => {
  const { data } = await authApi.post<any>(
    `${apiSupplierPrefix}/deleteSupplierOrderDetailsById`,
    {
      orderId,
      detailId: orderDetailsId,
    },
  );
  return data;
};
// supplier product codes
export const getSupplierCodes = async (
  id: number,
  pageNumber = 1,
  pageSize = 30,
): Promise<void | PaginatedSupplierProductCodes> => {
  const { data } = await authApi.post<PaginatedSupplierProductCodes>(
    `${apiSupplierPrefix}/supplierCodes`,
    {
      id,
      pageNumber,
      pageSize,
    },
  );

  return data ?? [];
};

// Check if the product id already exist
export const checkCode = async (
  productId: number,
): Promise<ProductCheckResponse> => {
  try {
    const { data } = await authApi.post<ProductCheckResponse>(
      `${apiSupplierPrefix}/check`,
      { productId },
    );
    return data;
  } catch (err: any) {
    // Axios throws for 409, but the backend still returns useful data
    if (err.response && err.response.status === 409) {
      return err.response.data as ProductCheckResponse;
    }

    // Re-throw unexpected errors
    throw err;
  }
};
// get supplier by id
export const getSupplierById = async (id: number): Promise<void | Supplier> => {
  return await authApi
    .post<Supplier>(`${apiSupplierPrefix}/getById`, { id })
    .then((resp) => resp.data);
};
// export const getSuppliers = async (id: number): Promise<void | Supplier> => {
//   return await authApi
//     .post<Supplier>(`${apiSupplierPrefix}/getById`, { id })
//     .then((resp) => resp.data);
// };

// submit supplier
export const submitSupplier = async (
  payload: any,
): Promise<void | Supplier> => {
  const { data } = await authApi.post<Supplier>(
    `${apiSupplierPrefix}/submit`,
    payload,
  );
  return data;
};
// submit supplier codes
export const submitSupplierCodes = async (
  payload: any,
): Promise<void | Supplier> => {
  const { data } = await authApi.post<Supplier>(
    `${apiSupplierPrefix}/submitCodes`,
    payload,
  );
  return data;
};
export const submitSupplierOrder = async (
  payload: any,
): Promise<void | SupplierOrderDataEntryForm> => {
  const { data } = await authApi.post<SupplierOrderDataEntryForm>(
    `${apiSupplierPrefix}/submitSupplierOrder`,
    payload,
  );
  return data;
};
//#endregion

//#region Supplier Orders
export const togglePrintState = async (
  id: number,
  printType: "summary" | "costing" | "prices",
): Promise<void> => {
  await authApi.post(`${apiSupplierPrefix}/setPrintState`, {
    id,
    printType,
  });
};
export const orderReceived = async (id: number): Promise<void> => {
  await authApi.post(`${apiSupplierPrefix}/orderReceived`, {
    id,
    isReceived: true,
  });
};
export const calculateSupplierOrderPricing = async (
  id: number,
): Promise<void> => {
  await authApi.post(`${apiSupplierPrefix}/calculateSupplierOrderPricing`, {
    orderId: id,
  });
};

export const getOrders = async (
  pageNumber: number = 1,
  pageSize: number = 30,
): Promise<void | PaginatedSupplierOrders> => {
  const { data } = await authApi.post<PaginatedSupplierOrders>(
    `${apiSupplierPrefix}/orders`,
    {
      pageNumber,
      pageSize,
    },
  );

  return data ?? [];
};
export const getSupplierOrderById = async (
  id: number,
  printMode: boolean = false,
): Promise<SupplierOrderDataEntryForm> => {
  return await authApi
    .post<SupplierOrderDataEntryForm>(
      `${apiSupplierPrefix}/supplierOrderById`,
      { id, printMode },
    )
    .then((resp) => resp.data);
};
// this rpt endpint handles both supplier costing and pricing reports
export const getRptSupplierOrders = async (
  id: number,
): Promise<RptSupplierOrders> => {
  const { data } = await authApi.post<RptSupplierOrders>(
    `${apiSupplierPrefix}/supplierOrders`,
    { id },
  );
  return data ?? { summary: null, details: [] };
};
//#endregion
